import { Messages } from '../../../codegen/Localize';
import { WindowLocationService } from '../../../commonInfra/services/WindowLocationService';
import { toNativePromise } from '../../../commonInfra/utils/QUtils';
import { DataSources } from '../../../content/resources/Datasources';
import { Workbooks } from '../../../content/resources/Workbooks';
import { Flows } from '../../../flow/resources/Flows';
import { IContentRevision } from '../../../revisionHistory/serverApi/types/IContentRevision';
import { L10n } from '../../L10n/L10n';
import { FlowDetailInfo } from '../../models/FlowInfo';
import { IDataSourceDetailInfo } from '../../models/IDataSourceInfo';
import { IWorkbookDetailInfo } from '../../models/IWorkbookInfo';
import { IDownloadItemInfo, INamedItemInfo } from '../../models/resourceInfoParts';
import { ToasterService, ToastType } from '../ToasterService';

export const toaster = ToasterService.instance;

function download(downloadItem: IDownloadItemInfo): boolean {
  if(!downloadItem.downloadUrl) return false;

  WindowLocationService.download(downloadItem.downloadUrl);
  return true;
}

function downloadFlow(flow: INamedItemInfo): Promise<FlowDetailInfo> {
  return Flows
    .getById(flow.id)
    .then((flow: FlowDetailInfo) => {
      const success = download(flow);
      if(!success) {
        toaster.pop({
          type: ToastType.Error,
          text: Messages.downloadFlowError({ NAME: L10n.elideIfLong(flow.name) })
        });
      }
      return flow;
    })
    .catch<FlowDetailInfo>((result: any) => {
      toaster.pop({
        type: ToastType.Error,
        text: Messages.downloadFlowError({ NAME: L10n.elideIfLong(flow.name) })
      });
      return Promise.reject(result);
    });
}

function downloadFlowDraft(flow: INamedItemInfo): Promise<FlowDetailInfo> {
  return toNativePromise(Flows
    .getDraft(flow.id)
    .then((flow: FlowDetailInfo) => {
      const success = download(flow);
      if(!success) {
        toaster.pop({
          type: ToastType.Error,
          text: Messages.downloadFlowError({ NAME: L10n.elideIfLong(flow.name) })
        });
      }
      return flow;
    })
    .catch<FlowDetailInfo>((result: any) => {
      toaster.pop({
        type: ToastType.Error,
        text: Messages.downloadFlowError({ NAME: L10n.elideIfLong(flow.name) })
      });
      return Promise.reject(result);
    }));
}

function downloadWorkbook(workbook: INamedItemInfo): Promise<IWorkbookDetailInfo> {
  return Workbooks
    .getById(workbook.id)
    .then((workbook: IWorkbookDetailInfo) => {
      const success = download(workbook);
      if(!success) {
        toaster.pop({
          type: ToastType.Error,
          text: Messages.downloadWorkbookError({ NAME: L10n.elideIfLong(workbook.name) })
        });
      }
      return workbook;
    })
    .catch<IWorkbookDetailInfo>((result: any) => {
      toaster.pop({
        type: ToastType.Error,
        text: Messages.downloadWorkbookError({ NAME: L10n.elideIfLong(workbook.name) })
      });
      return Promise.reject(result);
    });
}

function downloadDatasource(datasource: INamedItemInfo): Promise<IDataSourceDetailInfo> {
  return DataSources
    .getById(datasource.id)
    .then((datasource: IDataSourceDetailInfo) => {
      const success = download(datasource);
      if(!success) {
        toaster.pop({
          type: ToastType.Error,
          text: Messages.downloadDatasourceError({ NAME: L10n.elideIfLong(datasource.name) })
        });
      }
      return datasource;
    })
    .catch<IDataSourceDetailInfo>((result: any) => {
      toaster.pop({
        type: ToastType.Error,
        text: Messages.downloadDatasourceError({ NAME: L10n.elideIfLong(datasource.name) })
      });
      return Promise.reject(result);
    });
}

function downloadContentRevision(revision: IContentRevision): void {
  const success = download(revision);
  if(!success) {
    toaster.pop({ type: ToastType.Error, text: Messages.downloadRevisionError() });
  }
}

export const DownloadActions = {
  downloadContentRevision,
  downloadDatasource,
  downloadFlow,
  downloadFlowDraft,
  downloadWorkbook,
};

export type DownloadActions = typeof DownloadActions;